import { type FC, type PropsWithChildren } from 'react';

import { cn } from '../../utils';

interface TopNavbarProps {
  className?: string;
}

export const TopNavbar: FC<PropsWithChildren<TopNavbarProps>> = ({
  children,
  className,
}) => {
  return (
    <nav
      aria-label="navigation bar"
      className={cn(
        'dark min-h-24 w-full sticky top-0 left-0 p-6 bg-background text-foreground z-[100]',
        className,
      )}
    >
      {children}
      <Notch />
    </nav>
  );
};

export const TopNavBarTitlesWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex flex-col gap-1">{children}</div>;
};

export const TopNavBarTitle: FC<PropsWithChildren> = ({ children }) => {
  return <h1 className="text-2xl font-medium leading-tight ">{children}</h1>;
};

export const TopNavBarSubtitle: FC<PropsWithChildren> = ({ children }) => {
  return (
    <h2 className="text-sm text-muted-foreground leading-tight">{children}</h2>
  );
};

const Notch = () => {
  return (
    <svg
      className="absolute left-0 bottom-0 translate-y-full fill-background"
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.9258 0C22.7113 9.59032e-05 21.5654 0.563102 20.8232 1.52441L0.817383 27.4414C0.287733 28.1275 1.50667e-05 28.9701 0 29.8369V0H23.9258Z" />
    </svg>
  );
};
